// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__71xI9","checkbox-label":"Checkbox_checkbox-label__eVA+s","required":"Checkbox_required__NT+yF"};